"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoSection = void 0;
const react_1 = __importStar(require("react"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const shared_video_player_hover_bar_1 = require("@guidde-co/shared.video-player.hover-bar");
const shared_video_player_active_bar_1 = require("@guidde-co/shared.video-player.active-bar");
const shared_hooks_use_boolean_1 = require("@guidde-co/shared.hooks.use-boolean");
const mapSectionsToWidths = (sections) => sections.map(section => { var _a, _b; return ((_a = section.rangeValues) === null || _a === void 0 ? void 0 : _a[1]) - ((_b = section.rangeValues) === null || _b === void 0 ? void 0 : _b[0]); });
const useStyles = (0, makeStyles_1.default)({
    wrapper: {
        width: ({ width }) => `${width}%`,
        paddingBottom: ({ isEditMode }) => isEditMode ? '35px' : 0
    },
    section: {
        display: 'flex',
        alignItems: 'center',
        height: '10px',
        margin: '0 1px',
        position: 'relative',
        boxSizing: 'border-box',
        background: ({ isHidden, isDeleted }) => isHidden
            ? 'transparent'
            : isDeleted
                ? 'linear-gradient(-45deg, rgba(149, 146, 146, 0.6) 7.5%, rgba(255, 255, 255, 0.6) 7.5%, rgba(255, 255, 255, 0.6) 42.5%, rgba(149, 146, 146, 0.6) 42.5%, rgba(149, 146, 146, 0.6) 57.5%, rgba(255, 255, 255, 0.6) 57.5%, rgba(255, 255, 255, 0.6) 92.5%, rgba(149, 146, 146, 0.6) 92.5%) 0% 0% / 10px 10px'
                : '#828282'
    },
    index: {
        textAlign: 'center',
        position: 'absolute',
        fontSize: '10px',
        left: '4px',
        top: '-1px'
    }
});
exports.VideoSection = (0, react_1.memo)(({ index, isEditMode, sections, onSlice, onUpdateTime, videoElement, deleteButton, mergeButton, sliderButton }) => {
    var _a, _b, _c, _d;
    const isFirst = index === 0;
    const isLast = index === sections.length - 1;
    const isHidden = isFirst || isLast;
    const isDeleted = (_b = (_a = sections[index]) === null || _a === void 0 ? void 0 : _a.isDeleted) !== null && _b !== void 0 ? _b : false;
    const width = ((_c = sections[index].rangeValues) === null || _c === void 0 ? void 0 : _c[1]) - ((_d = sections[index].rangeValues) === null || _d === void 0 ? void 0 : _d[0]);
    const classes = useStyles({
        width,
        isHidden,
        isDeleted,
        isEditMode
    });
    const widths = mapSectionsToWidths(sections);
    const totalPrevWidth = widths
        .slice(0, index)
        .reduce((acc, cur) => acc + cur, 0);
    const [videoProgress, setVideoProgress] = (0, react_1.useState)(0);
    // We need to know which percent of current section is progressed based on videoProgress + width (full section percentage)
    const calculateSectionProgress = (0, react_1.useCallback)(() => {
        const leftProgress = videoProgress - totalPrevWidth;
        return leftProgress >= width
            ? 100
            : leftProgress <= 0
                ? 0
                : (leftProgress / width) * 100;
    }, [totalPrevWidth, videoProgress, width]);
    const sectionProgress = calculateSectionProgress();
    const pointed = (0, shared_hooks_use_boolean_1.useBoolean)();
    (0, react_1.useEffect)(() => {
        const newProgress = (target) => {
            const { currentTime, duration } = target;
            if (!currentTime || !duration)
                return 0;
            return +((currentTime / duration) * 100).toFixed(2);
        };
        videoElement === null || videoElement === void 0 ? void 0 : videoElement.addEventListener('timeupdate', e => {
            setVideoProgress(newProgress(e.target));
        });
        return () => {
            videoElement === null || videoElement === void 0 ? void 0 : videoElement.removeEventListener('timeupdate', e => {
                setVideoProgress(newProgress(e.target));
            });
        };
    }, [videoElement]);
    return (react_1.default.createElement(Box_1.default, { className: classes.wrapper, onPointerEnter: pointed.setTrue, onPointerLeave: pointed.setFalse },
        react_1.default.createElement(Box_1.default, { className: classes.section },
            !isHidden && (react_1.default.createElement(shared_video_player_hover_bar_1.HoverBar, { duration: (videoElement === null || videoElement === void 0 ? void 0 : videoElement.duration) || 0, onClick: onUpdateTime, width: width, totalPrevWidth: totalPrevWidth, index: index, totalSections: sections.length - 2, section: sections[index] })),
            react_1.default.createElement(shared_video_player_active_bar_1.ActiveBar, { progress: isHidden ? 0 : sectionProgress, background: isHidden
                    ? 'transparent'
                    : isDeleted
                        ? 'linear-gradient(-45deg, rgba(149, 146, 146, 0.6) 7.5%, rgba(255, 255, 255, 0.6) 7.5%, rgba(255, 255, 255, 0.6) 42.5%, rgba(149, 146, 146, 0.6) 42.5%, rgba(149, 146, 146, 0.6) 57.5%, rgba(255, 255, 255, 0.6) 57.5%, rgba(255, 255, 255, 0.6) 92.5%, rgba(149, 146, 146, 0.6) 92.5%) 0% 0% / 10px 10px'
                        : '#CB0000', onSlice: () => onSlice === null || onSlice === void 0 ? void 0 : onSlice((width / 100) * sectionProgress), showSlice: isEditMode &&
                    pointed.isTrue &&
                    (width / 100) * sectionProgress >= 4 && // in order to create a new slice it should be
                    (width / 100) * sectionProgress <= 96 // at least 4% from total duration
                , showEnd: (!isFirst &&
                    sectionProgress > 0 &&
                    Math.round(sectionProgress) < 100) ||
                    (index === 1 && sectionProgress === 0) ||
                    (isLast && Math.round(sectionProgress) === 100) }),
            !isHidden && isEditMode && (react_1.default.createElement(Box_1.default, { className: classes.index },
                react_1.default.createElement("b", null, index))),
            pointed.isTrue && deleteButton,
            sliderButton,
            mergeButton)));
});
//# sourceMappingURL=video-section.js.map